export default "__VITE_ASSET__C57zqchG__"